// extracted by mini-css-extract-plugin
export default {"fromHolder":"Login_fromHolder__6flTA","logo":"Login_logo__OIhNP"};